import { render, staticRenderFns } from "./BottomHeader.vue?vue&type=template&id=4f2959b4&scoped=true&"
import script from "./BottomHeader.vue?vue&type=script&lang=js&"
export * from "./BottomHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2959b4",
  null
  
)

export default component.exports